type SimulatedProgressOptions = {
  expectedDurationMs: number;
  maxProgress: number;
  updateIntervalMs: number;
};

const defaultOptions: SimulatedProgressOptions = {
  expectedDurationMs: 40000,
  maxProgress: 95,
  updateIntervalMs: 200,
};

export const createSimulatedProgress = (
  onUpdate: (progress: number) => void,
  options: Partial<SimulatedProgressOptions> = {}
) => {
  const { expectedDurationMs, maxProgress, updateIntervalMs } = {
    ...defaultOptions,
    ...options,
  };

  let intervalId: ReturnType<typeof setInterval> | null = null;
  let startTime: number | null = null;

  const timeConstant = expectedDurationMs / 2.3;

  const calculateProgress = (elapsed: number): number => {
    const rawProgress = maxProgress * (1 - Math.exp(-elapsed / timeConstant));
    return Math.min(rawProgress, maxProgress);
  };

  const start = () => {
    startTime = Date.now();

    intervalId = setInterval(() => {
      if (!startTime) return;

      const elapsed = Date.now() - startTime;
      const progress = calculateProgress(elapsed);

      onUpdate(progress);
    }, updateIntervalMs);
  };

  const stop = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    startTime = null;
  };

  const complete = () => {
    stop();
    onUpdate(100);
  };

  return { start, stop, complete };
};
